import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-manual-link',
  standalone: true,
  templateUrl: './manual-link.component.html',
  styleUrls: ['./manual-link.component.scss']
})
export class ManualLinkComponent {

  @Input() private _href = "#";
  private readonly baseUrl: string = 'https://reflact.github.io/engine';
  @Input() public set href(value: string) {
    if (value.startsWith('/')) {
      this._href = this.baseUrl + value;
    } else {
      this._href = value;
    }
  }

  public get href(): string {
    return this._href;
  }




}
